/* eslint jsx-a11y/aria-role: 0 */
/* eslint array-callback-return: 0 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {
  Link
} from 'react-router-dom'
import './categorybar.css';
import {fetchByCategory, setCurrentCategoryIndex, setActiveCategoryIndex} from '../../actions/api';
import {reset} from '../../actions/product';
import CategoryButton from '../CategoryButton';

import * as uri from '../../config/uri';
/* dropdown menu */
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import {getSvgIcon} from '../../helpers/productHelper.js'
import {scrollTo} from '../../actions/view'
import {hideCategoryBar, showCategoryBar} from '../../reducers/viewReducer';
import {isPaymentKiosk as isPaymentKioskSelector, getCategories} from '../../selectors/configSelectors';
import {getQueryParameters, pushWithQueryParams} from '../../services/uri';

var $ = require("jquery");

const styles = {
  moreInnerDivStyle: {
    padding: '0 12px 0 50px',
    fontSize: '16px',
    fontFamily: 'Futura-Bold',
    color: '#616161',
    lineHeight: '26px'
  },
};

class CategoryBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      moreItemsOpen: false,
      // currentCategoryIndex: -1,
      width: 0,
      height: 0
    }
  }

  handleMoreRequestClose = () => {
    this.setState({
      moreItemsOpen: false,
    });
  };

  updateDimensions = () => {
    this.setState({
      width: $(window).width(),
      height: $(window).height()
    });
  }

  componentWillMount = () => {
    this.updateDimensions();
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleMoreCategoryClick = (name, index) => {
    this.handleCategoryClick(name, index);
    this.setState({
      moreItemsOpen: false,
    });
  }

  handleCategoryClick = (name, index) => {
    if (this.props.activeCategoryIndex !== index) {
      this.props.scrollTo(0);
      this.props.setActiveCatIdx(index);
    }
  }

  handleMoreItemsClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      moreItemsOpen: true,
      anchorEl: event.currentTarget,
    });
  }

  handleCategoryAllClick = () => {
    this.props.reset();
  }

  getIsHidden = (index) => {
    if (this.state.width <= 1600 && this.state.width > 1080) {
      return index < 8 ? false : true;
    } else if (this.state.width <= 1080 && this.state.width > 900) {
      return index < 7 ? false : true;
    } else if (this.state.width <= 900 && this.state.width > 700) {
      return index < 7 ? false : true;
    } else if (this.state.width <= 650) {
      return index < 4 ? false : true;
    } else {
      return false;
    }
  }

  getCategories = (categories) => {
    const _categories = [...categories];
    _categories.forEach((category, index) => category.isHidden = this.getIsHidden(index));
    return categories;
  }

  getThereHiddenCat = (categories) => {
    return categories.filter(category => category.isHidden === true);
  }

  getAllProductCategory = () => {
    const {isPaymentKiosk} = this.props;
    return (
      <Link key="all" to={`${uri.rootPageUri}${getQueryParameters()}`}>
        <CategoryButton
          active={this.props.activeCategoryIndex === -1}
          onClick={this.handleCategoryAllClick}
          catName='ALL'
          isFetching={this.props.productsFetching}
          filterNameClass={isPaymentKiosk ? "filter-name-kiosk" : "filter-name"}
        />
      </Link>
    );
  }

  render() {
    const {isPaymentKiosk} = this.props;
    const categories = this.getCategories(this.props.categories);
    const isThereHidden = this.getThereHiddenCat(categories);
    const categoryFilterClass = 'filters-2' + (this.props.isPaymentKiosk ? ' payment-kiosk' : '');
    const path = this.props.router.location.pathname;

    return (
      <div className="filter-section">
        <FilterSection isFetching={this.props.productsFetching} className="filter-content">
          <div role="cat-filter" className={categoryFilterClass}>
            {isPaymentKiosk && this.getAllProductCategory()}
            {categories.map((category, index) => {
              if (!category.isHidden) {
                const active = this.props.activeCategoryIndex === index && path !== uri.rootPageUri;
                return (
                  <Link onClick={this.handleCategoryClick.bind(null, category.name, index)} key={category.id} to={{ pathname: `${uri.rootPageUri}category/${category.name.toLowerCase()}`, search: getQueryParameters() }}>
                    <CategoryButton
                      active={active}
                      role="category_button"
                      catName={category.name}
                      isFetching={this.props.productsFetching}
                      filterNameClass={isPaymentKiosk ? "filter-name-kiosk" : "filter-name"}
                    />
                  </Link>
                );
              }
            })}
            {/* more items dropdown menu */}
            {isThereHidden.length > 0 &&
              <div style={{display: 'flex'}}>
                <CategoryButton
                  catName={"MORE"}
                  onClick={this.handleMoreItemsClick}
                  filterNameClass={isPaymentKiosk ? "filter-name-kiosk" : "filter-name"}
                  active={this.state.moreItemsOpen}
                />
                <Popover
                  open={this.state.moreItemsOpen}
                  anchorEl={this.state.anchorEl}
                  anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                  targetOrigin={{horizontal: 'right', vertical: 'top'}}
                  onRequestClose={this.handleMoreRequestClose}
                  animation={PopoverAnimationVertical}
                  style={{right: 0, left: 'unset', width: 145}}
                  className={isPaymentKiosk ? "category-menu-kiosk" : "category-menu"}
                >
                  <Menu style={{paddingTop: 6}}>
                    {categories.map((category, index) => category.isHidden &&
                      <Link role="cat" key={category.id} to={{ pathname: `${uri.rootPageUri}category/${category.name.toLowerCase()}`, search: getQueryParameters() }}>
                        <MenuItem
                          style={{minHeight: '34px'}}
                          label={`type-${category.name}`}
                          onClick={this.handleMoreCategoryClick.bind(null, category.name, index)}
                          key={category.id}
                          primaryText={category.name}
                          innerDivStyle={styles.moreInnerDivStyle}
                          leftIcon={<img name={`type-${category.name}`} style={{top: '-12px'}} alt="icon" src={getSvgIcon(category.name)} />}
                        />
                      </Link>
                    )}
                  </Menu>
                </Popover>
              </div>
            }
          </div>
        </FilterSection>
      </div>
    );
  }
}

const FilterSection = styled.div`
    z-index: 0;
`;

const mapStateToProps = (state) => {
  return {
    categories: getCategories(state),
    currentCategoryIndex: state.products.currentCategoryIndex,
    activeCategoryIndex: state.products.activeCategoryIndex,
    router: state.router,
    productsFetching: state.products.fetching,
    isPaymentKiosk: isPaymentKioskSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideCatBar: () => dispatch(hideCategoryBar()),
    showCatBar: () => dispatch(showCategoryBar()),
    go: (path) => dispatch(pushWithQueryParams(path)),
    scrollTo: (pos) => dispatch(scrollTo(pos)),
    fetchByCategory: (name) => dispatch(fetchByCategory(name, 0, 20)),
    reset: (name) => dispatch(reset(name, 0, 20)),
    setCurrentCatIdx: (idx) => dispatch(setCurrentCategoryIndex(idx)),
    setActiveCatIdx: (idx) => dispatch(setActiveCategoryIndex(idx)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryBar);



// WEBPACK FOOTER //
// ./src/components/CategoryBar/CategoryBar.jsx